<template>
  <div class="parentx">
    <vs-sidebar class="v-nav-menu items-no-padding" v-model="isVerticalNavMenuActive" ref="verticalNavMenu"
      default-index="-1" :click-not-close="clickNotClose" :reduce-not-rebound="reduceNotRebound" :parent="parent"
      :hiddenBackground="clickNotClose" :reduce="reduce" v-hammer:swipe="onMenuSwipe">
      <div @mouseenter="mouseEnter" @mouseleave="mouseLeave">
        <!-- Header -->
        <div class="header-sidebar flex items-center justify-between" slot="header">
          <!-- Logo -->
          <router-link tag="div" class="vx-logo cursor-pointer flex items-center" :to="redirectPath">
            <div style="max-width: 60px; max-height: 60px">
              <img style="width: 100%; height: 100%; object-fit: cover;" key="onlineImg" :src="logoImage" alt="user-img" class="cursor-pointer block" />
            </div>
          </router-link>
        
          <!-- /Logo -->
          <div class="flex items-center" v-if="!verticalNavMenuItemsMin">
            <notification-drop-down v-if="showCloseButton" variant="icon" class="mr-1" />
            <div class="theme-toggle-circle" @click="themeMode = themeMode === 'dark' ? 'light' : 'dark'">
              <vs-icon icon-pack="feather" :icon="themeMode === 'dark' ? 'icon-sun' : 'icon-moon'" size="25px"
                color="dark" />
            </div>
          </div>
          <!-- Menu Buttons -->
          <div class="sidebar-close-button">
            <!-- Close Button -->
            <template v-if="showCloseButton">
              <feather-icon icon="XIcon" class="m-0 cursor-pointer"
                @click="$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)" />
            </template>

            <!-- Toggle Buttons -->
            <template v-else-if="!showCloseButton && !verticalNavMenuItemsMin">
              <feather-icon id="btnVNavMenuMinToggler" class="mr-0 cursor-pointer" :icon="'MenuIcon'"
                svg-classes="stroke-current text-primary" @click="toggleReduce(!reduce)" />
            </template>
          </div>
          <!-- /Menu Toggle Buttons -->
        </div>
        <!-- /Header -->

        <!-- Header Shadow -->
        <div class="shadow-bottom" v-show="showShadowBottom" />

        <!-- Menu Items -->
        <component :is="scrollbarTag" ref="verticalNavMenuPs" class="scroll-area-v-nav-menu pt-2" :settings="settings"
          @ps-scroll-y="psSectionScroll" @scroll="psSectionScroll" :key="$vs.rtl"
          :style="{ height: 'calc(100vh - 170px)' }">
          <template v-for="(item, index) in menuItemsUpdated">
            <!-- Group Header -->
            <!-- <span v-if="item.header && !verticalNavMenuItemsMin" class="navigation-header truncate" :key="`header-${index}`">
              {{ item.header }}
            </span> -->
            <!-- /Group Header -->
    
            <template v-if="!item.header">
              <!-- Nav-Item -->
              <v-nav-menu-item v-if="!item.submenu" :key="`item-${index}`" :index="index"
                :to="item.slug !== 'external' ? item.url : null" :href="item.slug === 'external' ? item.url : null"
                :icon="item.icon" :target="item.target" :isDisabled="item.isDisabled" :slug="item.slug">
                <span v-show="!verticalNavMenuItemsMin" class="truncate font-bold">{{ item.name }}</span>
                <span v-if="item.tag && (isMouseEnter || !reduce)" class="ml-auto nav-item-badge" :class="`badge-${item.tagColor || 'primary'}`">{{ item.tag }}</span>
              </v-nav-menu-item>
    
              <!-- Nav-Group -->
              <template v-else>
                <v-nav-menu-group :key="`group-${index}`" :openHover="openGroupHover" :group="item" :groupIndex="index"
                  :open="isGroupActive(item)" />
              </template>
              <!-- /Nav-Group -->
            </template>
          </template>
        </component>
        <!-- Sticky Profile -->
    
        <div class="the-navbar__user-meta sidebar-user-footer absolute bottom-0 p-4 w-full z-50">
          <div class="header-sidebar flex items-center justify-between p-4" v-if="localStorageGurudwaraImage">
            <div class="vx-logo cursor-pointer flex items-center router-link-active">
              <img style="width: 60px; height: 60px" key="onlineImg" :src="defaultLogoImage" alt="user-img"
                class="cursor-pointer block" />
            </div>
          </div>

          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <div class="flex items-center gap-2">
              <div class="con-img ml-3">
                <img key="onlineImg"
                  :src="image || 'https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?size=338&ext=jpg&ga=GA1.1.1141335507.1718323200&semt=ais_user'"
                  alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
              </div>

              <vs-dropdown-menu class="vx-navbar-dropdown" style="z-index: 99999">
                <ul style="min-width: 9rem">
                  <li @click="$router.push('/profile').catch(() => { })"
                    class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                    <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
                    <span class="ml-2">Profile</span>
                  </li>
                  <vs-divider class="m-1" />
                  <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
                    <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
                    <span class="ml-2">Logout</span>
                  </li>
                </ul>
              </vs-dropdown-menu>
              <div class="pl-2 text-right leading-tight hidden sm:block sidebar-user-footer__name">
                <p class="whitespace-normal font-semibold" v-show="!verticalNavMenuItemsMin">{{ displayUserName }}</p>
              </div>
            </div>
            <!-- <div>
              <img src="@/assets/images/elements/up-arrow.png" alt="" width="25px" />
            </div> -->
          </vs-dropdown>
        </div>

        <!-- <div class="absolute bottom-0 w-full p-4 bg-white border-t border-gray-200">
          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <div class="con-img ml-3">
              <img
                key="onlineImg"
                src="https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?size=338&ext=jpg&ga=GA1.1.1141335507.1718323200&semt=ais_user"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
            </div>

            <vs-dropdown-menu class="vx-navbar-dropdown" style="z-index: 99999">
              <ul style="min-width: 9rem">
                <li @click="$router.push('/profile').catch(() => {})" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                  <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">Profile</span>
                </li>
                <vs-divider class="m-1" />
                <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
                  <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">Logoutsssssssss</span>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>

        </div> -->
        <!-- /Sticky Profile -->
        <!-- /Menu Items -->
      </div>
    </vs-sidebar>

    <!-- Swipe Gesture -->
    <div v-if="!isVerticalNavMenuActive" class="v-nav-menu-swipe-area" v-hammer:swipe="onSwipeAreaSwipe" />
    <!-- /Swipe Gesture -->
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VNavMenuGroup from './VerticalNavMenuGroup.vue'
import VNavMenuItem from './VerticalNavMenuItem.vue'
import defaultLogo from '@/assets/images/sangat-logo.png'
import Logo from '../Logo.vue'
import NotificationDropDown from '@/layouts/components/navbar/components/NotificationDropDown.vue'

export default {
  name: 'v-nav-menu',
  components: {
    VNavMenuGroup,
    VNavMenuItem,
    VuePerfectScrollbar,
    Logo,
    NotificationDropDown
  },
  props: {
    logo: { type: String },
    openGroupHover: { type: Boolean, default: false },
    parent: { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    navMenuItems: { type: Array, required: true },
    title: { type: String }
  },
  data: () => ({
    userName: localStorage.getItem('userName'),
    image: localStorage.getItem('image'),
    logoImage: localStorage.getItem('gurudwaraImage') || defaultLogo,
    localStorageGurudwaraImage: localStorage.getItem('gurudwaraImage'),
    defaultLogoImage: defaultLogo,
    clickNotClose: false, // disable close navMenu on outside click
    isMouseEnter: false,
    reduce: false, // determines if navMenu is reduce - component property
    showCloseButton: false, // show close button in smaller devices
    settings: {
      // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: 1,
      swipeEasing: true
    },
    showShadowBottom: false
  }),
  computed: {
    themeMode: {
      get() { return this.$store.state.theme },
      set(val) { this.$store.dispatch('updateTheme', val) }
    },
    displayUserName() {
      const info = this.userInfo || {}
      const fullName = `${info.first_name || ''} ${info.last_name || ''}`.trim()
      return fullName || this.userName || 'Admin'
    },
    ...mapState('auth', ['user','userInfo']),
    ...mapState('feedback', ['unreadCount', 'gurudwaraOnboardCount']),
    ...mapState('book', { bookUnreadCount: 'unreadCount' }),
    ...mapState('adminNotifications', { bookingQuickCounts: 'quickCounts' }),
    ...mapGetters('auth', ['checkPermissionSlug', 'checkRolesByIds']),
    isGroupActive() {
      return (item) => {
        const path = this.$route.fullPath
        const routeParent = this.$route.meta ? this.$route.meta.parent : undefined
        let open = false

        const func = (item) => {
          if (item.submenu) {
            item.submenu.forEach((item) => {
              if (item.url && (path === item.url || routeParent === item.slug)) {
                open = true
              } else if (item.submenu) {
                func(item)
              }
            })
          }
        }
        func(item)
        return open
      }
    },
  menuItemsUpdated() {
      // Access user state to force re-computation when auth data loads
      // eslint-disable-next-line no-unused-vars
      const userInfo = this.userInfo

      const checkAccess = (item) => {
        return (this.checkRolesByIds(item.roles || []) || this.checkPermissionSlug(item.permissions || []))
      }

      const findAndTag = (item) => {
        const newItem = { ...item }
        if (newItem.slug === 'feedback' && this.unreadCount > 0) {
          newItem.tag = this.unreadCount
          newItem.tagColor = 'danger'
        }
        if (newItem.slug === 'BookList' && this.bookUnreadCount > 0) {
          newItem.tag = this.bookUnreadCount
          newItem.tagColor = 'danger'
        }
        if ((newItem.slug === 'gurudwara' || newItem.slug === 'GurudwaraOnboardList') && this.gurudwaraOnboardCount > 0) {
          newItem.tag = this.gurudwaraOnboardCount
          newItem.tagColor = 'danger'
        }
        const bookingCounts = this.bookingQuickCounts || {}
        const onGurudwaraPortal = String(window.location.hostname || '').toLowerCase().includes('mygurudwara')
          || ['mygurudwara', 'gurudwara'].includes(
            String(window.location.hostname || '').split('.')[0].toLowerCase().replace(/^(dev|stage|prod|test)-?/, '')
          )
        const newBookings = (Number(bookingCounts.prasad) || 0)
          + (Number(bookingCounts.sarai) || 0)
          + (onGurudwaraPortal ? 0 : Number(bookingCounts.hotel) || 0)
          + (Number(bookingCounts.anandKaraj) || 0)
          + (Number(bookingCounts.service) || 0)
        if (newItem.slug === 'GurudwaraList' && newBookings > 0) {
          newItem.tag = newBookings > 99 ? '99+' : newBookings
          newItem.tagColor = 'danger'
        }
        if (newItem.slug === 'gurudwara' && newBookings > 0 && !(this.gurudwaraOnboardCount > 0)) {
          newItem.tag = newBookings > 99 ? '99+' : newBookings
          newItem.tagColor = 'danger'
        }
        if (newItem.submenu) {
          newItem.submenu = newItem.submenu.filter(checkAccess).map(findAndTag)
        }
        if (newItem.items) {
          newItem.items = newItem.items.filter(checkAccess).map(findAndTag)
        }
        return newItem
      }

      const clone = []
      for (const [index, item] of this.navMenuItems.entries()) {
        if (!checkAccess(item)) continue

        const clonedItem = findAndTag(item)
        clone.push(clonedItem)

        if (item.header && item.items && item.items.length && (index || 1)) {
          for (const subItem of item.items) {
            if (checkAccess(subItem)) {
              clone.push(findAndTag(subItem))
            }
          }
        }
      }
      return clone
    },
    redirectPath() {
      const locationHostName = window.location.hostname
      if (locationHostName.includes('mygurudwara')) {
        return '/gurudwara/list'
      } else if (locationHostName.includes('artist')) {
        return '/audio/list'
      } else if (locationHostName.includes('myhotel')) {
        return '/hotel-dashboard'
      } else {
        return '/'
      }
    },
    isVerticalNavMenuActive: {
      get() {
        return this.$store.state.isVerticalNavMenuActive
      },
      set(val) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', val)
      }
    },
    layoutType() {
      return this.$store.state.mainLayoutType
    },
    reduceButton: {
      get() {
        return this.$store.state.reduceButton
      },
      set(val) {
        this.$store.commit('TOGGLE_REDUCE_BUTTON', val)
      }
    },
    isVerticalNavMenuReduced() {
      return Boolean(this.reduce && this.reduceButton)
    },
    verticalNavMenuItemsMin() {
      return this.$store.state.verticalNavMenuItemsMin
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    windowWidth() {
      return this.$store.state.windowWidth
    }
  },
  watch: {
    $route() {
      if (this.isVerticalNavMenuActive && this.showCloseButton) this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
    },
    reduce(val) {
      const verticalNavMenuWidth = val ? 'reduced' : this.$store.state.windowWidth < 1250 ? 'no-nav-menu' : 'default'
      this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)

      setTimeout(function () {
        window.dispatchEvent(new Event('resize'))
      }, 100)
    },
    layoutType() {
      this.setVerticalNavMenuWidth()
    },
    reduceButton() {
      this.setVerticalNavMenuWidth()
    },
    windowWidth() {
      this.setVerticalNavMenuWidth()
    }
  },
  methods: {
    pollUnreadCounts() {
      if (typeof document !== 'undefined' && document.hidden) return
      if (!localStorage.getItem('accessToken')) return

      const role = (this.userInfo && this.userInfo.role) || {}
      const slug = String(role.slug || role.role_name || localStorage.getItem('roleSlug') || '')
        .toLowerCase()
        .replace(/-/g, '_')
      const isGlobalAdmin = slug === 'admin' || slug === 'support_administrator'
      const canUseInbox =
        isGlobalAdmin || slug === 'gurudwara_admin' || slug === 'committee_admin'

      if (isGlobalAdmin) {
        this.$store.dispatch('feedback/getUnreadCount')
        this.$store.dispatch('book/getUnreadCount')
      }
      if (canUseInbox) {
        this.$store.dispatch('adminNotifications/fetchUnreadCount')
        this.$store.dispatch('adminNotifications/fetchInbox')
        this.$store.dispatch('adminNotifications/fetchQuickCounts')
      }
    },
    onVisibilityChange() {
      if (!document.hidden) this.pollUnreadCounts()
    },
    logout() {
      const theme = localStorage.getItem('theme')
      localStorage.clear()
      if (theme) localStorage.setItem('theme', theme)

      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push('/login').catch(() => { })
    },
    onMenuSwipe(event) {
      if (event.direction === 4 && this.$vs.rtl) {
        // Swipe Right
        if (this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = false
      } else if (event.direction === 2 && !this.$vs.rtl) {
        // Swipe Left
        if (this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = false
      }
    },
    onSwipeAreaSwipe(event) {
      if (event.direction === 4 && !this.$vs.rtl) {
        // Swipe Right
        if (!this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = true
      } else if (event.direction === 2 && this.$vs.rtl) {
        // Swipe Left
        if (!this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = true
      }
    },
    psSectionScroll() {
      const scroll_el = this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs
      this.showShadowBottom = scroll_el.scrollTop > 0
    },
    mouseEnter() {
      if (this.reduce) this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)
      this.isMouseEnter = true
    },
    mouseLeave() {
      if (this.reduce) this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', true)
      this.isMouseEnter = false
    },
    setVerticalNavMenuWidth() {
      if (this.windowWidth > 1250) {
        if (this.layoutType === 'vertical') {
          // Set reduce
          this.reduce = !!this.reduceButton

          // Open NavMenu
          this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin = !!(this.reduceButton && !this.isMouseEnter)
          this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

          // Menu Action buttons
          this.clickNotClose = true
          this.showCloseButton = false

          const verticalNavMenuWidth = this.isVerticalNavMenuReduced ? 'reduced' : 'default'
          this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)

          return
        }
      }

      // Close NavMenu
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      // Reduce button
      if (this.reduceButton) this.reduce = false

      // Menu Action buttons
      this.showCloseButton = true
      this.clickNotClose = false

      // Update NavMenu Width
      this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      // Remove Only Icon in Menu
      this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)

      // if(this.layoutType === 'vertical' || (this.layoutType === 'horizontal' && this.windowWidth < 1200))
      // if (this.windowWidth < 1200) {

      //   // Close NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      //   // Reduce button
      //   if (this.reduceButton) this.reduce = false

      //   // Menu Action buttons
      //   this.showCloseButton = true
      //   this.clickNotClose   = false

      //   // Update NavMenu Width
      //   this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      //   // Remove Only Icon in Menu
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)

      // } else {

      //   // Set reduce
      //   this.reduce = this.reduceButton ? true : false

      //   // Open NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

      //   // Set Menu Items Only Icon Mode
      //   const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

      //   // Menu Action buttons
      //   this.clickNotClose   = true
      //   this.showCloseButton = false

      //   const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
      //   this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)
      // }
    },
    toggleReduce(val) {
      this.reduceButton = val
      this.setVerticalNavMenuWidth()
    }
  },
  mounted() {
    this.setVerticalNavMenuWidth()
    this.pollUnreadCounts()
    this.feedbackInterval = setInterval(() => {
      this.pollUnreadCounts()
    }, 30000) // Poll every 30 seconds
    document.addEventListener('visibilitychange', this.onVisibilityChange)
  },
  beforeDestroy() {
    if (this.feedbackInterval) {
      clearInterval(this.feedbackInterval)
    }
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/components/verticalNavMenu.scss';

.nav-item-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  border-radius: 20px;
  font-size: 0.65rem;
  font-weight: 700;
  color: #fff;
  line-height: 1;
  text-align: center;
  z-index: 10;
  white-space: nowrap;
  letter-spacing: 0.5px;

  &.badge-danger {
    background: linear-gradient(118deg, #ea5455, rgba(234, 84, 85, 0.8));
    box-shadow: 0 2px 10px rgba(234, 84, 85, 0.4);
  }

  &.badge-primary {
    background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.8));
    box-shadow: 0 2px 10px rgba(115, 103, 240, 0.4);
  }

  &.badge-success {
    background: linear-gradient(118deg, #28c76f, rgba(40, 199, 111, 0.8));
    box-shadow: 0 2px 10px rgba(40, 199, 111, 0.4);
  }
}

.sidebar-user-footer {
  background-color: #ffffff;
  border-top: 1px solid #e5e7eb;
  color: #111827;

  .vs-con-dropdown,
  .con-vs-dropdown,
  .vs-dropdown--custom {
    background: transparent !important;
    box-shadow: none !important;
    border: 0 !important;
  }

  &__name p {
    color: #111827;
    font-weight: 600;
  }
}

.theme-dark .sidebar-user-footer {
  background-color: var(--page-bg, #10163a) !important;
  border-top-color: rgba(255, 255, 255, 0.14) !important;
  color: #f9fafb !important;

  &__name p {
    color: #f9fafb !important;
  }
}
</style>
